export function DouyinIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_4533_11034)">
        <rect width="58" height="58" rx="12" fill="#0B0B16" />
        <g clip-path="url(#clip1_4533_11034)">
          <path d="M35.9302 12.6089H30.4054V34.939C30.4054 37.5997 28.2805 39.7852 25.6361 39.7852C22.9918 39.7852 20.8669 37.5997 20.8669 34.939C20.8669 32.326 22.9446 30.1879 25.4945 30.0929V24.4867C19.8752 24.5816 15.342 29.1902 15.342 34.939C15.342 40.7355 19.9697 45.3915 25.6834 45.3915C31.397 45.3915 36.0246 40.6879 36.0246 34.939V23.4889C38.1024 25.0093 40.6522 25.912 43.3439 25.9595V20.3532C39.1885 20.2107 35.9302 16.7899 35.9302 12.6089Z" fill="white" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4533_11034">
          <rect width="58" height="58" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_4533_11034">
          <rect width="32.7826" height="32.7826" fill="white" transform="translate(12.6101 12.6089)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "DouyinIcon";
